module.exports = __webpack_public_path__ + "static/media/logo-320.986e6fd4.png";